import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PanAppState } from '@panamax/app-state';
import { combineLatest, map, Observable, of } from 'rxjs';
import { PageTitle } from 'src/app/shared/constants/page-titles.enum';
import { RebateTakeoutOptionsEnum } from '@usf/product-types';
import { CustomerRebatesService } from '@shared/services/customer-rebates/customer-rebates.service';
import { getRebateTakeoutOptionEnum } from '../utils/rebates.util';
import { UserService } from '@app/user/services/user.service';
@Injectable({
  providedIn: 'root',
})
export class RebatesResolverService {
  constructor(
    private panAppState: PanAppState,
    private router: Router,
    private translateService: TranslateService,
    private customerRebatesService: CustomerRebatesService,
    private userService: UserService,
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<RebateTakeoutOptionsEnum | undefined> {
    const takeoutOption = this.getTakeoutOptionFromRoute(route);
    if (!takeoutOption) {
      this.router.navigate(['/desktop/404']);
      return of(undefined);
    }

    return combineLatest([
      this.userService.showRebates$(),
      this.customerRebatesService.getTakeoutOptions(),
    ]).pipe(
      map(([showRebates, takeoutOptions]) => {
        const takeoutOptionEnum = getRebateTakeoutOptionEnum(takeoutOptions[0]);
        if (!showRebates || takeoutOptionEnum !== takeoutOption) {
          if (!showRebates || !takeoutOptionEnum) {
            this.router.navigate(['/desktop/404']);
          } else {
            this.router.navigate([
              '/desktop/customer-incentives',
              takeoutOptionEnum,
            ]);
          }
          return undefined;
        }
        let pageTitle: PageTitle;

        switch (takeoutOption) {
          case RebateTakeoutOptionsEnum.GetToKnowUs:
            pageTitle = PageTitle.getToKnowUs;
            break;
          case RebateTakeoutOptionsEnum.PartnerWithUs:
            pageTitle = PageTitle.partnerWithUs;
            break;
        }
        this.panAppState.setPageTitle(this.translateService.instant(pageTitle));
        return takeoutOption;
      }),
    );
  }

  getTakeoutOptionFromRoute(
    route: ActivatedRouteSnapshot,
  ): RebateTakeoutOptionsEnum {
    const takeoutOptionParam = route.paramMap.get(
      'takeoutOption',
    ) as RebateTakeoutOptionsEnum;
    return Object.values(RebateTakeoutOptionsEnum).includes(takeoutOptionParam)
      ? takeoutOptionParam
      : undefined;
  }
}
